// src/pages/Dashboard/sections/network-tabs/PointsAnalysisTab.jsx
import React from 'react';

/**
 * Points Analysis Tab Component
 * Displays points history and summary data
 */
const PointsAnalysisTab = ({
  pointsData,
  pointsPeriod,
  setPointsPeriod,
  formatNumber
}) => {
  return (
    <div className="points-content">
      <div className="points-controls">
        <h3>Points Analysis</h3>
        <div className="period-selector">
          <label>Time Period:</label>
          <select 
            value={pointsPeriod} 
            onChange={(e) => setPointsPeriod(e.target.value)}
          >
            <option value="7d">7 Days</option>
            <option value="30d">30 Days</option>
            <option value="90d">90 Days</option>
            <option value="1y">1 Year</option>
          </select>
        </div>
      </div>
      
      {pointsData.length > 0 ? (
        <>
          <div className="points-summary-cards">
            <div className="points-card">
              <div className="points-value">
                {formatNumber(pointsData.reduce((sum, entry) => sum + (entry.amount || 0), 0), 0)}
              </div>
              <div className="points-label">Total Points</div>
            </div>
            <div className="points-card">
              <div className="points-value">
                {formatNumber(pointsData.length > 0 ? 
                  pointsData.reduce((sum, entry) => sum + (entry.amount || 0), 0) / pointsData.length : 0, 0)}
              </div>
              <div className="points-label">Average Daily Points</div>
            </div>
            <div className="points-card">
              <div className="points-value">
                {formatNumber(Math.max(...pointsData.map(entry => entry.amount || 0)), 0)}
              </div>
              <div className="points-label">Highest Points</div>
            </div>
            <div className="points-card">
              <div className="points-value">
                {formatNumber(Math.min(...pointsData.map(entry => entry.amount || 0)), 0)}
              </div>
              <div className="points-label">Lowest Points</div>
            </div>
          </div>
          
          <div className="points-sources-section">
            <h3>Points History</h3>
            <div className="table-responsive">
              <table className="points-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Points</th>
                    <th>Source</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {pointsData.map((entry, index) => (
                    <tr key={index}>
                      <td>{new Date(entry.timestamp).toLocaleDateString()}</td>
                      <td className="value-col">{formatNumber(entry.amount, 0)}</td>
                      <td className="source-col">{entry.source || 'System'}</td>
                      <td>{entry.description || 'Points Generation'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="no-data-message">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <p>No points data available for the selected period.</p>
        </div>
      )}
    </div>
  );
};

export default PointsAnalysisTab;
